/** Client-side record that the user accepted the staking legal docs. */

import { resolveLocale } from '@incpt/i18n';

const KEY = 'incpt_staking_legal_v1';

type LegalDoc = 'terms' | 'aml' | 'privacy';
export type StakingLegalUrls = Record<LegalDoc, string>;

/** English defaults — also what `/v1/staking` returns. */
export const STAKING_LEGAL_DEFAULTS: StakingLegalUrls = {
  terms: 'https://incpt.io/terms/',
  aml: 'https://incpt.io/aml/',
  privacy: 'https://incpt.io/privacy/',
};

/** Path segment on incpt.io for translated legal pages (`uk` → `ukr`). */
function legalLocaleSegment(locale: string): 'ru' | 'ukr' | null {
  const lang = resolveLocale(locale);
  if (lang === 'ru') return 'ru';
  if (lang === 'uk') return 'ukr';
  return null;
}

function incptLegalUrl(doc: LegalDoc, locale: string): string {
  const segment = legalLocaleSegment(locale);
  return segment ? `https://incpt.io/${doc}/${segment}/` : `https://incpt.io/${doc}/`;
}

/** Locale-specific Terms / AML / Privacy links for the stake UI. */
export function stakingLegalForLocale(locale: string): StakingLegalUrls {
  return {
    terms: incptLegalUrl('terms', locale),
    aml: incptLegalUrl('aml', locale),
    privacy: incptLegalUrl('privacy', locale),
  };
}

export function loadStakingLegal(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function saveStakingLegal(accepted: boolean): void {
  try {
    if (accepted) localStorage.setItem(KEY, '1');
    else localStorage.removeItem(KEY);
  } catch {
    /* private mode / quota */
  }
}

export function openStakingLegal(url: string): void {
  const wa = window.Telegram?.WebApp;
  if (wa?.openLink) wa.openLink(url);
  else window.open(url, '_blank', 'noopener,noreferrer');
}
